module.exports = __webpack_public_path__ + "logo_socialnet.c2907e5d1631ec42983a.svg";


//////////////////
// WEBPACK FOOTER
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/assets/img/logo/logo_socialnet.svg
// module id = ../../../../../src/assets/img/logo/logo_socialnet.svg
// module chunks = styles